import { render, staticRenderFns } from "./fiveBond.vue?vue&type=template&id=1c88c22e&scoped=true&"
import script from "./fiveBond.vue?vue&type=script&lang=js&"
export * from "./fiveBond.vue?vue&type=script&lang=js&"
import style0 from "./fiveBond.vue?vue&type=style&index=0&id=1c88c22e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c88c22e",
  null
  
)

export default component.exports